import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import reducerRegistry from "../../reducerRegistry";
import { getPage } from "../Page/actions";
import { getItems } from "./actions";
import { REDUCER_NAME } from "./constants";
import Component from "./memberClubPage";
import reducer, { selectIsError, selectIsReady, selectItems } from "./reducer";

const mapDispatchToProps = (dispatch) => ({
  onGetPage: (data) => dispatch(getPage(data)),
  onGetItems: (data) => dispatch(getItems(data)),
});

const mapStateToProps = createStructuredSelector({
  isReady: selectIsReady,
  isError: selectIsError,
  items: selectItems,
});

const MemberClubPage = compose(connect(mapStateToProps, mapDispatchToProps))(
  Component
);

export default MemberClubPage;

reducerRegistry.register(REDUCER_NAME, reducer);
